import { render, staticRenderFns } from "./EcocolordopplerAortaAddominaleEditComponent.vue?vue&type=template&id=2d4c17af&scoped=true"
import script from "./EcocolordopplerAortaAddominaleEditComponent.vue?vue&type=script&lang=js"
export * from "./EcocolordopplerAortaAddominaleEditComponent.vue?vue&type=script&lang=js"
import style0 from "./EcocolordopplerAortaAddominaleEditComponent.vue?vue&type=style&index=0&id=2d4c17af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c17af",
  null
  
)

export default component.exports